import React, { useContext, useState } from 'react';

import AppContext from '../../../context';
import {
  generateSmallCaseTransaction,
  fetchUserHoldingsKite,
  fetchUserHoldingsSmallcase,
} from '../../../../api';
import {
  KiteIcon,
  AngelBrokingIcon,
  UpstoxIcon,
  GrowwIcon,
  FivepaisaIcon,
  DhanIcon,
  MotilalIcon,
  TrustlineIcon,
} from '../../../../assets/icons';
import { LockIcon } from '../../../../assets/misc';
import { ReactComponent as AngleLeft } from '../../../../assets/icons/angle-left.svg';
import { ReactComponent as Cross } from '../../../../assets/icons/cross.svg';
import { ReactComponent as HomeTrendUp } from '../../../../assets/icons/home-trend-up.svg';
import { ReactComponent as PlusCircle } from '../../../../assets/icons/plus-circle.svg';
import { ReactComponent as AngleRightGrey } from '../../../../assets/icons/angle-right-grey.svg';
import UpgradeModal from '../../../common/upgrade_modal/upgrade_modal.component';
import './empty_pf.component.css';

const EmptyPf = (props) => {
  const context = useContext(AppContext);
  const { pfId, setStep, setAddtxFromRef, onClose, onSync, setShowImportMFs } =
    props;
  const pf = context.portfoliosById[pfId];

  const [isUpgradeModalVisible, setIsUpgradeModalVisible] = useState(false);

  const fetchHoldings = async () => {
    try {
      // get jwt token
      const res = await generateSmallCaseTransaction(pfId);
      window.django.smallcase = {};
      window.django.smallcase.token = res.data.token;
      window.django.smallcase.tx_id = res.data.tx_id;
      const gatewayInstance = new window.scDK({
        // ! Use valid gateway name here
        gateway: 'tijori',
        /*
         * ! Use valid auth token
         * Details - https://developers.gateway.smallcase.com/docs/kickstart-integration#jwt--json-web-tokens
         */
        smallcaseAuthToken: window.django.smallcase.token,
        config: {
          // Should allow after market orders?
          amo: true,
        },
      });
      gatewayInstance.init({
        smallcaseAuthToken: window.django.smallcase.token,
      });
      // trigger tx
      const tx = await gatewayInstance.triggerTransaction({
        transactionId: window.django.smallcase.tx_id,
        brokers: context.brokers,
      });

      //fetch holdings
      const holdings = await fetchUserHoldingsSmallcase(
        pfId,
        tx.smallcaseAuthToken,
      );
      onSync();
    } catch (error) {
      if (error.message && error.message === 'user_cancelled') {
        return;
      }
      console.log(error);
    }
  };

  const fetchKiteHoldings = async () => {
    try {
      //fetch holdings
      const res = await fetchUserHoldingsKite(pfId);
      onSync();
      return;
    } catch (error) {
      if (error.response && error.response.data.redirect_url) {
        const frame = document.createElement('iframe');
        frame.src = error.response.data.redirect_url;
        frame.classList.add('kite-frame');
        document.body.append(frame);
        window.addEventListener('message', (e) => {
          if (
            e.origin != window.location.origin ||
            typeof e.data != 'string' ||
            !JSON.parse(e.data).source === 'sync_capture'
          )
            return;
          const status = JSON.parse(e.data).status;
          if (status === 'success') {
            onSync();
          }
          frame.remove();
          return;
        });
        return;
      }
      console.log(error);
    }
  };

  return (
    <>
      <section className="modal-header">
        <div className="head">
          <button
            type="button"
            onClick={() => {
              setStep('manage_one');
            }}
          >
            <AngleLeft />
          </button>
          <span className="head">Manage Portfolio</span>
        </div>
        <button type="button" onClick={onClose}>
          <Cross />
        </button>
      </section>
      <section className="empty_pf p-4">
        <section className="pf-add-data-cont">
          <div className="pf-add-data-option">
            <div className="connect_icon">
              <HomeTrendUp />
            </div>
            <h4>Connect to your Broker</h4>
            <p>Instantly pull your holdings</p>
            <p>All features except IRR and Sharpe ratio</p>
            <div className="brokers">
              <div onClick={fetchKiteHoldings} className="br bb">
                <img src={KiteIcon} alt="zerodha" />
                <div>Zerodha</div>
              </div>
              <div onClick={fetchHoldings} className="br bb">
                <img src={AngelBrokingIcon} alt="angel one" />
                <div>Angel One</div>
              </div>
              <div onClick={fetchHoldings} className="br bb">
                <img src={UpstoxIcon} alt="upstox" />
                <div>Upstox</div>
              </div>
              <div onClick={fetchHoldings} className="bb">
                <img src={GrowwIcon} alt="groww" />
                <div>Groww</div>
              </div>
              <div onClick={fetchHoldings} className="br">
                <img src={FivepaisaIcon} alt="5paisa" />
                <div>5paisa</div>
              </div>
              <div onClick={fetchHoldings} className="br">
                <img src={DhanIcon} alt="dhan" />
                <div>Dhan</div>
              </div>
              <div onClick={fetchHoldings} className="br">
                <img src={MotilalIcon} alt="motilal oswal" />
                <div>Motilal Oswal</div>
              </div>
              <div onClick={fetchHoldings}>
                <img src={TrustlineIcon} alt="trustline" />
                <div>Trustline</div>
              </div>
            </div>
          </div>
          <div className="divider">
            <div className="line"></div>
            <div className="my-2">or</div>
            <div className="line"></div>
          </div>
          <div className="pf-add-data-option">
            <div className="connect_icon">
              <HomeTrendUp />
            </div>
            <h4>Manual and Bulk Upload</h4>
            <p>Drag your tradebook or manually enter transactions</p>
            <p>Do this if you want to see IRR</p>
            {context.planDetails.name === 'free' ? (
              <button
                type="button"
                variant="primary"
                className="add_invst_btn"
                onClick={() => setIsUpgradeModalVisible(true)}
              >
                <img src={LockIcon} alt="locked" className="lock-icon" />
                <span>Add Manual & Bulk Upload</span>
              </button>
            ) : (
              <button
                type="button"
                variant="primary"
                onClick={() => {
                  setAddtxFromRef();
                  setStep('addtx_one');
                }}
                className="add_invst_btn"
              >
                <PlusCircle /> <span>Add Manual & Bulk Upload</span>
              </button>
            )}
          </div>
          {context.planDetails.name === 'free' ? (
            <button
              type="button"
              variant="primary"
              className="add_invst_btn mob"
              onClick={() => setIsUpgradeModalVisible(true)}
            >
              <img src={LockIcon} alt="locked" className="lock-icon" />
              <span>Add Manually</span>
            </button>
          ) : (
            <button
              type="button"
              variant="primary"
              onClick={() => {
                setAddtxFromRef();
                setStep('addtx_one');
              }}
              className="add_invst_btn mob"
            >
              Add Manually
            </button>
          )}
          {!pf.has_mfs && (
            <button
              type="button"
              className="import_mfs"
              onClick={() => {
                setShowImportMFs(true);
                onClose();
              }}
            >
              Skip and Import Mutual funds
              <AngleRightGrey />
            </button>
          )}
        </section>
      </section>
      {context.planDetails.name === 'free' ? (
        <UpgradeModal
          isVisible={isUpgradeModalVisible}
          setIsVisible={setIsUpgradeModalVisible}
        />
      ) : null}
    </>
  );
};

export default EmptyPf;
